import React, { useEffect } from "react";
import "./LeafParticles.css";

const LeafParticles = () => {
  useEffect(() => {
    const container = document.querySelector(".leaf-container");

    const createLeaf = () => {
      const leaf = document.createElement("img");
      leaf.src = "images/fly_leaf.png"; // <-- Put your leaf image inside /public folder
      leaf.className = "leaf";

      // Random horizontal position
      leaf.style.left = Math.random() * 100 + "vw";

      // Random animation duration
      leaf.style.animationDuration = 5 + Math.random() * 5 + "s";

      // Random size
      const size = 20 + Math.random() * 40;
      leaf.style.width = `${size}px`;
      leaf.style.height = "auto";

      // Append
      container.appendChild(leaf);

      // Remove after animation ends
      setTimeout(() => leaf.remove(), 10000);
    };

    const interval = setInterval(createLeaf, 700); // generate leaf every 0.4sec
    return () => clearInterval(interval);
  }, []);

  return <div className="leaf-container container-fluid"></div>;
};

export default LeafParticles;
